import { useCallback, useMemo } from "react";

import Select, { SelectOption } from "components/Select";

import { useQuickStartContext } from "./QuickStartCard";
import { FIXED_WIDTH } from "./constants";
import { trackWelcomeDashboardProgrammingLanguageChange } from "utils/Tracking";

export type WantedOutputFormats = 'markdown' | 'text';


const outputFormatList: SelectOption<WantedOutputFormats>[] = [
  {
    name: "Markdown",
    value: "markdown"
  },
  {
    name: "Text",
    value: "text"
  },
];


export default function OutputFormatSelect() {
  const { selectedOutputFormat, setSelectedOutputFormat } = useQuickStartContext();

  const selectedFormat = useMemo(() => {
    return outputFormatList.find(format => format.value === selectedOutputFormat) || outputFormatList[0];
  }, [ selectedOutputFormat ]);

  const changeOutputFormat = useCallback((outputFormat: SelectOption<WantedOutputFormats>) => {
    setSelectedOutputFormat(outputFormat.value);
    trackWelcomeDashboardProgrammingLanguageChange(outputFormat.value);
  }, [ setSelectedOutputFormat ]);


  return (
    <Select
      value={ selectedFormat }
      onChange={ changeOutputFormat }
      options={ outputFormatList }
      size="SM"
      className={ FIXED_WIDTH }
    />
  );
};
